import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './EbonStatusBadge.scss';

const EbonStatusBadge = ({ status, remainingBalance, totalAmount, i18nPage }) => {
    const getBadgeInfo = () => {
        if (!status || status === 'UNKNOWN') {
            return {
                type: 'not-filled',
                text: i18nPage.STATUS.NOT_FILLED
            };
        }

        if (status === 'USED' || status === 'VALIDATED') {
            return {
                type: 'consumed',
                text: i18nPage.STATUS.CONSUMED
            };
        }

        if (status === 'CURRENTLY_IN_USE' || status === 'PENDING') {
            if (remainingBalance !== undefined && remainingBalance !== null && totalAmount) {
                const remaining = parseFloat(remainingBalance);
                if (remaining > 0 && remaining < totalAmount) {
                    const formattedAmount = remaining.toFixed(2).replace('.', ',');
                    return {
                        type: 'in-progress-amount',
                        text: i18nPage.STATUS.IN_PROGRESS_WITH_AMOUNT.replace('{0}', formattedAmount)
                    };
                }
            }
            return {
                type: 'in-progress',
                text: i18nPage.STATUS.IN_PROGRESS
            };
        }

        return {
            type: 'not-filled',
            text: i18nPage.STATUS.NOT_FILLED
        };
    };

    const badgeInfo = getBadgeInfo();

    return (
        <span className={`ebon-status-badge badge-${badgeInfo.type}`}>
            {badgeInfo.text}
        </span>
    );
};

EbonStatusBadge.propTypes = {
    status: PropTypes.string,
    remainingBalance: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    i18nPage: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    i18nPage: state.i18n.page.ACCOUNT.EBONS
});

export default connect(mapStateToProps)(EbonStatusBadge);



// WEBPACK FOOTER //
// ./src/components/pages/account/myebons/EbonStatusBadge.js